import { useMutation } from "@tanstack/react-query";
import uploadsApiClient from "api/uploads";

const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(file);
  });
};

const useUploadOnboardingImages = () => {
  return useMutation({
    mutationFn: async (files: File[]): Promise<string[]> => {
      const base64Files = await Promise.all(files.map(fileToBase64));
      const response =
        await uploadsApiClient.uploadOnboardingImages(base64Files);
      return response.urls;
    },
  });
};

export default useUploadOnboardingImages;
